import React, { useContext, useEffect, useState } from "react";
import ViewportContext from "../../../../context/studyviewer/ViewportContext";
import Viewport from "./Viewport";
import MPRViewport from "./MPRViewport";
import { isMobile } from "react-device-detect";
import { VIEWPORT_COLUMN, VIEWPORT_ROW } from "../../../../constants/Constants";
import { resizeViewport } from "../../helpers/CornerstoneViewportService";
import $ from "jquery";
import studyviewerContext from "../../../../context/studyviewer/StudyviewerContext";
import ThumbnailContext from "../../../../context/studyviewer/ThumbnailContext";
import themeContext from "../../../../context/theme/ThemeContext";

const ViewportLayout = ({ priors,initialVOI }) => {
  const {
    viewportRow,
    viewportColumn,
    activeViewportIndex,
    isMPRActive,
    activeMPRViewportIndex,
    isCompareActive,
    isSagittalActive,
    setIsSagittalActive,
    isAxialActive,
    setIsAxialActive,
    isCoronalActive,
    setIsCoronalActive,
    activeTool,
    viewportSeriesData,
    viewportDoubleClickIndex
  } = useContext(ViewportContext);

  const { studyParentId, viewerOpacity } = useContext(studyviewerContext);
  const {getThemeColor} = useContext(themeContext);

  const [rows] = useState(() => {
    let array = [];
    for (let i = 0; i < VIEWPORT_ROW; i++) {
      array.push(i);
    }
    return array;
  });
  const [columns] = useState(() => {
    let array = [];
    for (let i = 0; i < VIEWPORT_COLUMN; i++) {
      array.push(i);
    }
    return array;
  });

  useEffect(() => {
    
  }, [viewportRow, viewportColumn]);

  const [height, setHeight] = useState();
  const [width, setWidth] = useState();

  useEffect(() => {
    setHeight(
      viewportRow === 1
        ? isMobile
          ? 99
          : !isCompareActive
          ? 98
          : 96
        : !isCompareActive
        ? (100 - (viewportRow + 1)) / viewportRow
        : (100 - (viewportRow + 1)) / viewportRow - 1
    );
    setWidth(
      viewportColumn === 1
        ? isMobile
          ? 98
          : 99
        : (100 - (viewportColumn + 1) * 0.5) / viewportColumn
    );
    if (!isMobile) {
      const resizeViewportInterval = setInterval(() => {
        resizeViewport();
      }, 500);
      setTimeout(() => {
        clearInterval(resizeViewportInterval);
      }, 500);
    }
  }, [viewportRow, viewportColumn, isCompareActive]);

  useEffect(() => {
    const viewportContainer = $(`#viewport-box-${activeViewportIndex}`);
    viewportContainer.addClass("blinking");
    setTimeout(() => {
      viewportContainer.removeClass("blinking");
    }, 1000);
  }, [activeViewportIndex, activeTool]);

  return (
    <>
      <div
        className="viewport-layout-container"
        // style={{
        //   display: `${!isMPRActive ? "block" : "none"}`,
        //   height: `${isMobile ? "100%" : "98%"}`,
        // }}
        style={{
            position: isMPRActive ? "absolute" : "static",
            opacity: isMPRActive  ? 0 : 1,
            pointerEvents: isMPRActive ? "none" : "auto",
            zIndex: isMPRActive ? -1 : "auto",
            height: `${isMobile ? "100%" : "98%"}`,
          }}
      >
        {/* VIEWPORT 1 */}
        {rows.length > 0 &&
          columns.length > 0 &&
          rows.map((i) =>
            columns.map((j, index) => {
              return (
                <React.Fragment key={index}>
                  {i < viewportRow && j < viewportColumn && (
                    <div
                      className={`viewport-layout-inner-container ${(
                        viewportSeriesData[i * 3 + j]?.study != null &&
                        String(viewportSeriesData[i * 3 + j]?.study) === studyParentId && priors
                      ) ? "active-viewport-top-border" : ""}`}
                      style={{
                        // display: `${
                        //    ? "block" : "none"
                        // }`,
                        height:  viewportDoubleClickIndex === -1 || viewportDoubleClickIndex == null
                        ? `${height}%` // Default height for all viewports
                        : '98%',

                        width:  viewportDoubleClickIndex === -1 || viewportDoubleClickIndex == null
                        ? `${width}%` // Default height for all viewports
                        : '98%',     

                        // height: `${height}%`,
                        // width: `${width}%`,
                        // top: `${
                        //   isMobile
                        //     ? "0.5"
                        //     : isCompareActive
                        //     ? i * height + i + 3
                        //     : i * height + i + 1
                        // }%`,
                        // left: `${
                        //   isMobile ? "0.25" : (j * width + j * 0.5 + 0.5 - 0.2)
                        // }%`,
                        top: viewportDoubleClickIndex === -1 || viewportDoubleClickIndex == null
                          ? `${
                              isMobile
                                ? "0.5"
                                : isCompareActive
                                ? i * height + i + 3
                                : i * height + i + 1
                            }%`
                          : "1%",

                        left: viewportDoubleClickIndex === -1 || viewportDoubleClickIndex == null
                          ? `${
                              isMobile
                                ? "0.25"
                                : j * width + j * 0.5 + 0.5 - 0.2
                            }%`
                          : "1%",
                        display: viewportDoubleClickIndex === -1 || viewportDoubleClickIndex == null
                          ? "block" 
                          : viewportDoubleClickIndex === i * 3 + j
                          ? "block" 
                          : "none", 
                      }}
                    >
                      <div
                        id={`viewport-box-${i * 3 + j}`}
                        className={`viewport-layout-viewport h100 w100`}
                        style={{
                          border: `${
                            activeViewportIndex === i * 3 + j
                              ? "3px solid "+getThemeColor("active-viewport")
                              : "1px solid rgb(255,255,255,0.3)"
                          }`,
                          backgroundColor: 'black',
                        }}
                      >
                        <div className="h100 w100" style={{
                          opacity: `${viewerOpacity}`,
                        }}>
                          <Viewport viewportIndex={i * 3 + j} priors={priors} setInitialVOI={initialVOI}/>
                        </div>
                      </div>
                    </div>
                  )}
                </React.Fragment>
              );
            })
          )}
      </div>

      {/* MPR VOLUME VIEWPORTS */}
      {isMPRActive && (
        <div
          className="viewport-layout-mpr-viewport-container w100"
          style={{
            display: `${isMPRActive ? "block" : "none"}`,
          }}
        >
          {/* VIEWPORT 1 */}
          <div
            className="viewport-layout-mpr-viewport"
            style={{
              visibility: `${
                isMPRActive && (isSagittalActive || isCoronalActive)
                  ? "hidden"
                  : ""
              }`,
              height: `${isMobile ? "32%" : "98%"}`,
              width: `${isMobile ? "100%" : isAxialActive ? "99%" : "32.66%"}`,
              top: `${isMobile ? "1%" : "1%"}`,
              left: `${isMobile ? "0.5%" : "0.5%"}`,
            }}
          >
            <div
              onDoubleClick={() => {
                setIsAxialActive(!isAxialActive);
                resizeViewport();
              }}
              className="viewport-layout-viewport h100 w100"
              // style={{
              //   borderColor: `${
              //     activeMPRViewportIndex === 0
              //       ? "rgb(255,255,255,0.7)"
              //       : "rgb(255,255,255,0.3)"
              //   }`,
              // }}
              style={{
                borderColor: `${
                  activeMPRViewportIndex === 0
                    ? getThemeColor("active-viewport") 
                    : "rgb(255,255,255,0.3)"
                }`,
                borderWidth: activeMPRViewportIndex === 0 ? "3px" : "1px",
              }}
            >
              <MPRViewport orientation={"axial"} viewportIndex={0} setInitialVOI={initialVOI} />
            </div>
          </div>
          {/* VIEWPORT 2 */}
          <div
            className="viewport-layout-mpr-viewport"
            style={{
              visibility: `${
                isMPRActive && (isAxialActive || isCoronalActive)
                  ? "hidden"
                  : ""
              }`,
              width: `${
                isMobile ? "100%" : isSagittalActive ? "99%" : "32.66%"
              }`,
              height: `${isMobile ? "32%" : "98%"}`,
              top: `${isMobile ? "34%" : "1%"}`,
              left: `${
                isMobile ? "0.5%" : isSagittalActive ? "0.5%" : "33.66%"
              }`,
            }}
          >
            <div
              onDoubleClick={() => {
                setIsSagittalActive(!isSagittalActive);
                resizeViewport();
              }}
              className="viewport-layout-viewport h100 w100"
              // style={{
              //   borderColor: `${
              //     activeMPRViewportIndex === 1
              //       ? "rgb(255,255,255,0.7)"
              //       : "rgb(255,255,255,0.3)"
              //   }`,
              // }}
              style={{
                borderColor: `${
                  activeMPRViewportIndex === 1
                    ? getThemeColor("active-viewport") 
                    : "rgb(255,255,255,0.3)"
                }`,
                borderWidth: activeMPRViewportIndex === 1 ? "3px" : "1px",
              }}
            >
              <MPRViewport orientation={"sagittal"} viewportIndex={1}  setInitialVOI={initialVOI}/>
            </div>
          </div>
          {/* VIEWPORT 3 */}
          <div
            className="viewport-layout-mpr-viewport"
            style={{
              visibility: `${
                isMPRActive && (isAxialActive || isSagittalActive)
                  ? "hidden"
                  : ""
              }`,
              width: `${
                isMobile ? "100%" : isCoronalActive ? "99%" : "32.66%"
              }`,
              height: `${isMobile ? "32%" : "98%"}`,
              top: `${isMobile ? "67%" : "1%"}`,
              left: `${
                isMobile ? "0.5%" : isCoronalActive ? "0.5%" : "66.82%"
              }`,
            }}
          >
            <div
              onDoubleClick={() => {
                setIsCoronalActive(!isCoronalActive);
                resizeViewport();
              }}
              className="viewport-layout-viewport h100 w100"
              // style={{
              //   borderColor: `${
              //     activeMPRViewportIndex === 2
              //       ? "rgb(255,255,255,0.7)"
              //       : "rgb(255,255,255,0.3)"
              //   }`,
              // }}
              style={{
                borderColor: `${
                  activeMPRViewportIndex === 2
                    ? getThemeColor("active-viewport") 
                    : "rgb(255,255,255,0.3)"
                }`,
                borderWidth: activeMPRViewportIndex === 2 ? "3px" : "1px",
              }}
            >
              <MPRViewport orientation={"coronal"} viewportIndex={2} setInitialVOI={initialVOI}/>
            </div>
          </div>
        </div>
      )}
    </>
  );
};

export default ViewportLayout;
